import { injectGlobal } from "styled-components";

injectGlobal`
  body {
    font-size: 100%;
    line-height: 1.5;
    color: #222;
  }

  h1, h2, h3, h4 {

  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.5rem;
  }

  h4 {
    font-size: 1.25rem;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/typography.js